import React from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';
import imageTrWhite from '../images/imageTrWhite.png';
import logoutIcon from '../images/logout.png';
import loginIcon from '../images/user-interface.png';

function Header({ isLoggedIn = false, onLogout = null, onLogin = null }) {
  const handleLogoutClick = () => {
    if (onLogout) {
      onLogout();
    }
  };

  const handleLoginClick = () => {
    if (onLogin) {
      onLogin();
    }
  };

  return (
    <nav className="mask">
      <Link to="/"><img className="imiig" src={imageTrWhite} alt="Albumified logo" /> albumified</Link>
      <ul className="list">
        <li><Link to="/">Rewind</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/projects">Projects</Link></li>
        <li><Link to="/privacy" className="spacer">Privacy Policy</Link></li>
      </ul>
      {isLoggedIn ? (
        <button className="logoutIcon topNav" onClick={handleLogoutClick}>
          <img className="imiig2" id="logout-button" src={logoutIcon} alt="Logout" title="Logout" />
        </button>
      ) : (
        <button className="loginIcon topNav" onClick={handleLoginClick} title="Login">
          <img className="imiig2" id="login-button" src={loginIcon} alt="Login" title="Login" />
        </button>
      )}
    </nav>
  );
}

export default Header;

